import { API_REQUEST, API_INVALIDATE_PATH } from '../lib/api/constants';
import * as ENDPOINTS from '../constants/endpoints';

export const CHECK_KTI_RULES_ENABLED_REQUEST =
  'KTI_RULES/CHECK_ENABLED_REQUEST';
export const CHECK_KTI_RULES_ENABLED_SUCCESS =
  'KTI_RULES/CHECK_ENABLED_SUCCESS';
export const CHECK_KTI_RULES_ENABLED_ERROR = 'KTI_RULES/CHECK_ENABLED_ERROR';

export const FETCH_KTI_RULES_REQUEST = 'KTI_RULES/FETCH_REQUEST';
export const FETCH_KTI_RULES_SUCCESS = 'KTI_RULES/FETCH_SUCCESS';
export const FETCH_KTI_RULES_ERROR = 'KTI_RULES/FETCH_ERROR';

export const UPDATE_KTI_RULES_REQUEST = 'KTI_RULES/UPDATE_REQUEST';
export const UPDATE_KTI_RULES_SUCCESS = 'KTI_RULES/UPDATE_SUCCESS';
export const UPDATE_KTI_RULES_ERROR = 'KTI_RULES/UPDATE_ERROR';

export const PUBLISH_KTI_RULES_REQUEST = 'KTI_RULES/PUBLISH_REQUEST';
export const PUBLISH_KTI_RULES_SUCCESS = 'KTI_RULES/PUBLISH_SUCCESS';
export const PUBLISH_KTI_RULES_ERROR = 'KTI_RULES/PUBLISH_ERROR';

export const checkKtiRulesEnabledRequest = () => ({
  type: CHECK_KTI_RULES_ENABLED_REQUEST,
});

export const checkKtiRulesEnabledSuccess = data => ({
  type: CHECK_KTI_RULES_ENABLED_SUCCESS,
  payload: data,
});

export const checkKtiRulesEnabledError = error => ({
  type: CHECK_KTI_RULES_ENABLED_ERROR,
  payload: error,
});

export const checkKtiRulesEnabled = () => async dispatch => {
  dispatch(checkKtiRulesEnabledRequest());

  try {
    const response = await dispatch({
      type: API_REQUEST,
      path: ENDPOINTS.KTI_RULES_ENABLED,
      method: 'GET',
      name: 'checkKtiRulesEnabled',
    });

    dispatch(checkKtiRulesEnabledSuccess(response));
    return response;
  } catch (error) {
    dispatch(
      checkKtiRulesEnabledError(
        error.message || 'Failed to check KTI rules status',
      ),
    );
    throw error;
  }
};

export const fetchKtiRulesRequest = () => ({
  type: FETCH_KTI_RULES_REQUEST,
});

export const fetchKtiRulesSuccess = data => ({
  type: FETCH_KTI_RULES_SUCCESS,
  payload: data,
});

export const fetchKtiRulesError = error => ({
  type: FETCH_KTI_RULES_ERROR,
  payload: error,
});

export const fetchKtiRules = () => async dispatch => {
  dispatch(fetchKtiRulesRequest());

  try {
    const response = await dispatch({
      type: API_REQUEST,
      path: ENDPOINTS.KTI_RULES,
      method: 'GET',
      name: 'fetchKtiRules',
    });

    dispatch({
      type: API_INVALIDATE_PATH,
      path: ENDPOINTS.KTI_RULES,
    });

    dispatch(fetchKtiRulesSuccess(response));
    return response;
  } catch (error) {
    dispatch(fetchKtiRulesError(error.message || 'Failed to fetch KTI rules'));
    throw error;
  }
};

export const updateKtiRulesRequest = () => ({
  type: UPDATE_KTI_RULES_REQUEST,
});

export const updateKtiRulesSuccess = data => ({
  type: UPDATE_KTI_RULES_SUCCESS,
  payload: data,
});

export const updateKtiRulesError = error => ({
  type: UPDATE_KTI_RULES_ERROR,
  payload: error,
});

export const updateKtiRules = updatedFields => (dispatch, getState) => {
  dispatch(updateKtiRulesRequest());

  try {
    const { ktiRulesReducer } = getState();
    const ruleData = {
      ...ktiRulesReducer.data,
      ...updatedFields,
    };

    const response = {
      payload: ruleData,
      error: null,
    };
    dispatch(updateKtiRulesSuccess(response));
    return response;
  } catch (error) {
    dispatch(
      updateKtiRulesError(error.message || 'Failed to update KTI rules'),
    );
    throw error;
  }
};

export const publishKtiRulesRequest = () => ({
  type: PUBLISH_KTI_RULES_REQUEST,
});

export const publishKtiRulesSuccess = data => ({
  type: PUBLISH_KTI_RULES_SUCCESS,
  payload: data,
});

export const publishKtiRulesError = error => ({
  type: PUBLISH_KTI_RULES_ERROR,
  payload: error,
});

export const publishKtiRules = () => async (dispatch, getState) => {
  dispatch(publishKtiRulesRequest());

  try {
    const { ktiRulesReducer } = getState();
    const currentData = ktiRulesReducer.data;

    dispatch({
      type: API_INVALIDATE_PATH,
      path: ENDPOINTS.KTI_RULES,
    });

    const response = await dispatch({
      type: API_REQUEST,
      path: ENDPOINTS.KTI_RULES,
      method: 'POST',
      body: JSON.stringify(currentData),
      name: 'publishKtiRules',
    });

    if (response.error) {
      dispatch(
        publishKtiRulesError(
          response.error.message || 'Failed to publish KTI rules',
        ),
      );
      return response;
    }

    dispatch(publishKtiRulesSuccess(response));
    return response;
  } catch (error) {
    dispatch(
      publishKtiRulesError(error.message || 'Failed to publish KTI rules'),
    );
    throw error;
  }
};
